import React from 'react';
import {
  CheckCircleIcon,
  InformationCircleIcon,
  ExclamationCircleIcon,
  XCircleIcon,
  XMarkIcon,
} from '@heroicons/react/20/solid';

export const CheckIcon: React.FC = () => (
  <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
);

export const InfoIcon: React.FC = () => (
  <InformationCircleIcon className="h-5 w-5 text-blue-400" aria-hidden="true" />
);

export const WarningIcon: React.FC = () => (
  <ExclamationCircleIcon
    className="h-5 w-5 text-yellow-400"
    aria-hidden="true"
  />
);

export const ErrorIcon: React.FC = () => (
  <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
);

export const Dismiss: React.FC = () => (
  <XMarkIcon className="h-5 w-5" aria-hidden="true" />
);
